/**
 * Figma Node IDs:
 * Design Frame: 1:10985
 * Instance IDs: 4022:4797, 4022:5061, 4022:5063, 4022:5065
 * Composite: true
 * Last Updated: 2024-12-23
 * Generated by: Claude Code figma-component command
 */
import React from "react";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { AudioButton, type FoundationAudioProps } from "../AudioButton";
import { baseBodyTextClass, sizeVariants } from "./BodyText.css";

type TextElement = "p" | "span";

export interface BodyTextProps
  extends React.HTMLAttributes<HTMLElement>, FoundationAudioProps {
  children: React.ReactNode;
  size?: "l" | "m" | "s";
  className?: string;
  component?: TextElement;
  equation?: boolean;
}

export const BodyText: React.FC<BodyTextProps> = ({
  children,
  size = "l",
  className = "",
  component: Component = "p",
  equation = false,
  audioSrc,
  ...rest
}) => {
  const combinedClassName = [baseBodyTextClass, sizeVariants[size], className]
    .filter(Boolean)
    .join(" ");

  return (
    <Component className={combinedClassName} {...rest}>
      {audioSrc && <AudioButton src={audioSrc} />}
      <RichText value={children} equation={equation} />
    </Component>
  );
};
